module.exports = __webpack_public_path__ + "img/38.d1ae5720.webp";